import { Translate } from '@/hooks/useTranslation';

export type CapsuleViewMode = 'content' | 'reactions';

export const getCapsuleViewOptions = (t: Translate) => [
  { key: 'content' as const, label: t('common.content') },
  { key: 'reactions' as const, label: t('common.reactions') },
];

export const defaultCapsuleView: CapsuleViewMode = 'reactions';
